import { defineStore } from 'pinia'
import { collection, onSnapshot } from 'firebase/firestore'
import { db } from '@/firebase/init'
import { LabAccount } from '@/globals/typescript/models/LabAccount'

export const useLabStore = defineStore('lab', {
  state: () => ({
    allLabAccounts: [] as LabAccount[],

    unsubscribeAllLabAccounts: null as (() => void) | null,
  }),

  actions: {
    getAllLabAccounts(): Promise<LabAccount[]> {
      if (this.allLabAccountsLoaded) {
        return Promise.resolve(this.allLabAccounts)
      }

      return new Promise((resolve) => {
        let resolved = false
        const unsubscribe = onSnapshot(
          collection(db, 'Apps', '-lab-management-', 'LabAccounts'),
          (querySnapshot) => {
            this.allLabAccounts = querySnapshot.docs.map(
              (doc) => new LabAccount(doc.data() as LabAccount)
            )
            this.unsubscribeAllLabAccounts = unsubscribe
            if (!resolved) {
              resolved = true
              resolve(this.allLabAccounts)
            }
          }
        )
      })
    },

    resetStore() {
      this.allLabAccounts = []

      if (this.unsubscribeAllLabAccounts) {
        this.unsubscribeAllLabAccounts()
        this.unsubscribeAllLabAccounts = null
      }
    },
  },

  getters: {
    // Loaders
    allLabAccountsLoaded: (state) => {
      return !!state.unsubscribeAllLabAccounts
    },
  },
})

